<div class="flex button-wrapper" [ngClass]="{'justify-content-space-between': secondaryButtonText, 'justify-content-end': !secondaryButtonText}">
    <button *ngIf="secondaryButtonText"
            mat-flat-button
            color="gray"
            (click)="secondaryButtonClick.emit()">
        {{secondaryButtonText}}
    </button>

    <button mat-flat-button
            color="accent"
            (click)="primaryButtonClick.emit()"
            [disabled]="isPrimaryButtonDisabled()">
        {{primaryButtonText}}
    </button>
</div>
